/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Intro_Compliance_BlurbInputs */



/**
* | output |
* | --- |
* | "Compliance keeps AI use within your rules. Set pattern rules to audit or block sensitive content, and optionally let a Compliance AI assess each interaction'..." |
*
* @param {Uno_Edu_Intro_Compliance_BlurbInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_intro_compliance_blurb = /** @type {((inputs?: Uno_Edu_Intro_Compliance_BlurbInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Intro_Compliance_BlurbInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Compliance hält die KI-Nutzung innerhalb Ihrer Regeln. Legen Sie Musterregeln fest, um sensible Inhalte zu protokollieren oder zu blockieren, und lassen Sie optional eine Compliance-KI das Risiko jeder Interaktion bewerten.")
	return /** @type {LocalizedString} */ ("Compliance keeps AI use within your rules. Set pattern rules to audit or block sensitive content, and optionally let a Compliance AI assess each interaction's risk.")
});